import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { get } from 'http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductServiceService {

  constructor(
    public dialog: MatDialog,
    private _bottomSheet: MatBottomSheet,
    private http: HttpClient,
    private snackbar: MatSnackBar,
  ) {
    this.subIndustryName = localStorage.getItem('subIndustryName');
    this.isJewellery = localStorage.getItem('isMaterialBasedPricing') === 'true' ? true : false;
  }

  subIndustryName: any;
  isJewellery: boolean = false;


  openDialog(componentName: any, height: any, width: any, maxWidth: any, dataModel: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      maxWidth: maxWidth,
      data: dataModel,
      disableClose: true,
      position: { right: '0px', top: '0px' },
    });
  }

  openSocialBrand(componentName: any, height: any, width: any, data: any, maxWidth: string = '100vw', maxHeight: string = '100vh') {
    return this.dialog.open(componentName, {
      height: height,
      width: width,
      data: data,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    });
  }

  openBottomSheet(componentName: any, data: any) {
    return this._bottomSheet.open(componentName, {
      data: data,

    });
  }

  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 5000 });
  }

  getProductList(data: any, isJewellery: boolean) {
    if (!data.request)
      data.request = 'BUSINESS';

    return this.http.put(
      environment.baseUrl + `ecommerce/product/item/search?isJewellery=${isJewellery}`, data
    )
  }

  searchProductItems(data: any) {
    if (!data.request)
      data.request = 'BUSINESS';

    return this.http.put(
      environment.baseUrl + `ecommerce/product/item/search?isJewellery=${this.isJewellery}`, data
    )
  }

  getProductBySlug(slugifiedName: string, isJewellery: boolean) {
    let bDetailsRaw = localStorage.getItem('bDetails');
    let businessDetails = bDetailsRaw ? JSON.parse(bDetailsRaw) : null;
    let data = {
      pageNo: 0,
      pageSize: 1,
      slugifiedName: slugifiedName,
      subIndustryId: localStorage.getItem('subIndustryId') || businessDetails?.subIndustryId,
      businessId: localStorage.getItem('businessId'),
    }
    return this.http.put(
      environment.baseUrl + `ecommerce/product/itemV2/search?isJewellery=${isJewellery}`, data
    )
  }

  deleteProduct(productId: any, subIndustryName: string) {
    if (localStorage.getItem('isMaterialBasedPricing') === 'false') {
      return this.http.delete(
        environment.baseUrl + `ecommerce/product/variant?itemId=${productId}`
      )
    }
    else {
      return this.http.delete(
        environment.baseUrl + `ecommerce/jewellery/deleteJewelryItem?itemId=${productId}`
      )
    }
  }

  searchCategories(data: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/inventory/get/category`, data
    )
  }
  searchCollection(data: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/inventory/get/collection`, data
    )
  }
  createCategories(data: any) {

    let isJewellery = localStorage.getItem('isMaterialBasedPricing') === 'true' ? true : false;
    return this.http.post(
      environment.baseUrl + `ecommerce/inventory/item/category?isJewellery=${isJewellery}`, data
    )
  }
  getcategoriesList(data: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/inventory/get/category`, data
    )
  }
  deleteCategories(categoryId: any) {
    return this.http.delete(
      environment.baseUrl + `ecommerce/inventory/category?categoryId=${categoryId}`
    )
  }
  getitemsListByCategories(data: any, isJewellery: boolean) {
    if (!data.request)
      data.request = 'BUSINESS';

    return this.http.put(
      environment.baseUrl + `ecommerce/product/item/search?isJewellery=${isJewellery}`, data
    )
  }

  getCategoryListByCollectionId(collectioId: string) {
    return this.http.get(
      environment.baseUrl + `ecommerce/inventory/category/collectionId?collectionId=${collectioId}`
    )
  }

  getCollectionList(data: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/inventory/get/collection`, data
    )
  }
  createCollection(data: any, isJewellery: boolean) {
    return this.http.post(
      environment.baseUrl + `ecommerce/inventory/item/collection?isJewellery=${isJewellery}`, data
    )
  }
  deleteCollection(collectionId: any) {
    return this.http.delete(
      environment.baseUrl + `ecommerce/inventory/collection?collectionId=${collectionId}`
    )
  }

  exportItem(businessId: any) {
    return this.http.get(
      environment.baseUrl + `ecommerce/product/export?businessId=${businessId}`, { responseType: 'blob' }
    )
  }

  downloadSampleExcel(subIndustryId: any) {
    return this.http.get(
      environment.serverIp + `ecommerce/export?subIndustryId=${subIndustryId}`, { responseType: 'blob' }
    )
  }

  importItem(businessId: any, businessName: any, formData: FormData) {
    const headers = new HttpHeaders();
    headers.set('Accept', 'application/json');
    headers.delete('Content-Type');
    return this.http.post(
      environment.baseUrl + `ecommerce/product/import?businessId=${businessId}&businessName=${businessName}`, formData, { headers: headers }
    )
  }

  // Rating & Review APIs (need business Id)
  getAllReviewText(): Observable<unknown> {
    return this.http.get(environment.baseUrl + 'ecommerce/user/all');
  }


  //Price List APIs
  createMetal(payload: any, date: any) {
    return this.http.post(environment.baseUrl + `ecommerce/jewellery/addMetalPrice?date=${date}`, payload);
  }

  getMetalPriceList(page: number, size: number) {
    return this.http.get(environment.baseUrl + `ecommerce/jewellery/jewelryMaterial?businessId=${localStorage.getItem('businessId')}&page=${page}&size=${size}`);
  }

  getYesterdaysData() {
    return this.http.get(environment.baseUrl + `ecommerce/jewellery/latestGoldPrice?businessId=${localStorage.getItem('businessId')}`)
  }


  searchCatalogue(data: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/inventory/get/collection`, data
    )
  }
  getCatalogueList(businessId?: any, catalogueId?: any, searchText?: any) {
    let url = `${environment.baseUrl}ecommerce/inventory/catalogue?`;

    const params: string[] = [];

    if (businessId) {
      params.push(`businessId=${businessId}`);
    }

    if (catalogueId) {
      params.push(`catalogueId=${catalogueId}`);
    }

    if (searchText && searchText.trim() !== '') {
      params.push(`searchText=${encodeURIComponent(searchText.trim())}`);
    }

    if (params.length > 0) {
      url += params.join('&');
    }

    return this.http.get(url);
  }



  createCatalogue(data: any) {
    return this.http.post(
      environment.baseUrl + `ecommerce/inventory/catalogue`, data
    )
  }
  updateCatalogue(data: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/inventory/catalogue`, data
    )
  }

  deleteCatalogue(catalogueId: any) {
    return this.http.delete(
      environment.baseUrl + `ecommerce/inventory/catalogue/${catalogueId}`
    )
  }
  checkCataloguePassword(catId, pwd) {
    return this.http.post(
      environment.baseUrl + `ecommerce/inventory/catalogue/checkPassword?catalogueId=${catId}&password=${pwd}`, ''
    )
  }

  createMaterial(payload: any) {
    return this.http.post(environment.baseUrl + `ecommerce/jewellery/jewelryMaterial`, payload);
  }

  deleteMaterial(materialId: any) {
    return this.http.delete(
      environment.baseUrl + `ecommerce/jewellery/jewelryMaterial?materialId=${materialId}`
    )
  }

  getAllGroupedMaterials() {
    return this.http.get(
      environment.baseUrl + `ecommerce/jewellery/jewelryMaterialGrouped?businessId=${localStorage.getItem('businessId')}&grouped=true`
    )
  }

  updateMaterialStatus(id: any, active: any) {
    return this.http.delete(
      environment.baseUrl + `ecommerce/jewellery/jewelryMaterial?materialMasterId=${id}&active=${active}`
    )
  }

}
